import { Building2, BadgeCheck, Clapperboard, Share2 } from "lucide-react";

export const AUDIENCES = [
  { key: "business", icon: Building2, title: "Business / Brand", copy: "Campaigns, creator matching, and content for products and brands.", cta: "Grow My Brand" },
  { key: "affiliate", icon: BadgeCheck, title: "Lifted Affiliate", copy: "Already part of the Lifted family? Promote your affiliate profile and content.", cta: "Promote My Profile" },
  { key: "creator", icon: Clapperboard, title: "Content Creator / Influencer", copy: "Spotlights, collaborations, and brand partnerships for independent creators.", cta: "Apply as a Creator" },
  { key: "social_promotion", icon: Share2, title: "Social Media Promotion", copy: "Request promotion of your social accounts across Lifted channels.", cta: "Promote My Socials" },
];

export const SERVICES = [
  ["social_account_promotion", "Social media account promotion"],
  ["creator_spotlight", "Creator spotlights on Lifted platforms"],
  ["affiliate_profile_promotion", "Affiliate profile promotion"],
  ["product_collaboration", "Product collaborations"],
  ["cross_promotion", "Cross-promotion opportunities"],
  ["content_production", "Content production and editing"],
  ["brand_partnership", "Brand partnerships"],
  ["social_campaign_support", "Social media campaign support"],
  ["event_launch_promotion", "Event and launch promotion"],
  ["creator_networking", "Creator discovery and networking"],
];

export const PLATFORMS = [
  ["instagram", "Instagram", "@handle or instagram.com/handle"],
  ["tiktok", "TikTok", "@handle or tiktok.com/@handle"],
  ["youtube", "YouTube", "@channel or youtube.com/@channel"],
  ["twitch", "Twitch", "twitch.tv/handle"],
  ["facebook", "Facebook", "facebook.com/page"],
  ["x", "X", "@handle or x.com/handle"],
  ["other", "Other", "https://…"],
];

export const CATEGORIES = [
  ["lifestyle", "Lifestyle"], ["cannabis_culture", "Cannabis culture"],
  ["fashion_streetwear", "Fashion / Streetwear"], ["music", "Music"],
  ["comedy", "Comedy"], ["gaming", "Gaming"], ["art_design", "Art / Design"],
  ["fitness_wellness", "Fitness / Wellness"], ["food", "Food"],
  ["education", "Education"], ["other", "Other"],
];

export const labelOf = (list, key) => (list.find((x) => x[0] === key) || [key, key])[1];

export function errMsg(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
}
